import type { SyntheticEvent } from "react";
import { LANDING_DESKTOP_UX_MQ } from "./landingConstants";

/** Blocks native context menu on desktop only (does not stop determined users). */
export function preventContextMenuOnDesktop(e: SyntheticEvent): void {
  if (typeof window === "undefined") return;
  if (window.matchMedia(LANDING_DESKTOP_UX_MQ).matches) {
    e.preventDefault();
  }
}
